import { FC } from "react";

import styles from './styles.module.scss'

type Props = {
    color?: string;
    label?: string;
    size?: number;
};

const Avatar: FC<Props> = ({ color, label, size }) => {
    return (
        <div className={`${styles.background}`} style={{ backgroundColor: color, width: size, height: size }}>
            <span className={styles.aic_account_letter}>{label}</span>
        </div>
    );
};

export default Avatar;
